import { API_URL } from '../../../../utils/config';

export const GET_DEPARTMENTS_URL = `${API_URL}/department`;

